import {
  ApplicationConfig,
  importProvidersFrom,
  APP_INITIALIZER,
} from '@angular/core';
import {
  TranslateModule,
  TranslateLoader,
  TranslateService,
} from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import {
  provideHttpClient,
  HttpClientModule,
  withInterceptors,
} from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';

// No factory needed; using provideTranslateHttpLoader helper.
import { authInterceptor } from './shared/services/auth-interceptor.service';

// AOT-friendly factory for ngx-translate loader. Returns a simple TranslateLoader
// that loads `./assets/i18n/{lang}.json`.
export function HttpLoaderFactory(
  http: HttpClient,
  document: Document,
): TranslateLoader {
  // Build an absolute URL for the i18n assets using the document base href.
  // This avoids requests like '/current/route/assets/i18n/en.json' which
  // won't be served and won't appear under DevTools Sources.
  const prefix = new URL('assets/i18n/', document.baseURI).href;
  console.log('[i18n][HttpLoaderFactory] computed prefix =', prefix);
  return {
    getTranslation: (lang: string) =>
      http.get<Record<string, string>>(`${prefix}${lang}.json`),
  } as TranslateLoader;
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([authInterceptor])),
    importProvidersFrom(
      HttpClientModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient, DOCUMENT],
        },
      }),
    ),
    provideRouter(routes),
    // Initialize language from localStorage if present
    {
      provide: APP_INITIALIZER,
      useFactory: (translate: TranslateService) => {
        return () => {
          const stored = localStorage.getItem('lang');
          const initial =
            stored && ['es', 'en'].includes(stored) ? stored : 'es';
          translate.setDefaultLang('es');
          return translate
            .use(initial)
            .toPromise()
            .catch(() => {
              console.warn(
                '[APP_INITIALIZER][i18n] failed to load language files for',
                initial,
              );
            });
        };
      },
      deps: [TranslateService],
      multi: true,
    },
  ],
};
